export default function getEnv(name) {
  // In production (Docker), use window.configs
  if (window?.configs?.[name]) {
    return window.configs[name];
  }

  // In development, we need to access process.env directly
  // because webpack only replaces direct property access, not bracket notation
  const envMap = {
    'VUE_APP_DEFAULT_TITLE': process.env.VUE_APP_DEFAULT_TITLE,
    'VUE_APP_LOGO_URL': process.env.VUE_APP_LOGO_URL,
    'VUE_APP_PLATFORM_NAME': process.env.VUE_APP_PLATFORM_NAME,
    'VUE_APP_NAV_TITLE': process.env.VUE_APP_NAV_TITLE,
    'VUE_APP_NAV_SUBTITLE': process.env.VUE_APP_NAV_SUBTITLE,
    'VUE_APP_TOOLBAR_TITLE': process.env.VUE_APP_TOOLBAR_TITLE,
    'VUE_APP_MOBIHOME_TITLE': process.env.VUE_APP_MOBIHOME_TITLE,
    'VUE_APP_MOBIHOME_DESCRIPTION': process.env.VUE_APP_MOBIHOME_DESCRIPTION,
    'VUE_APP_API_URL': process.env.VUE_APP_API_URL,
    'VUE_APP_DATA_URL': process.env.VUE_APP_DATA_URL,
    'VUE_APP_SESSION_DURATION': process.env.VUE_APP_SESSION_DURATION,
    'VUE_APP_LOGIN_DELEGATE': process.env.VUE_APP_LOGIN_DELEGATE,
    'VUE_APP_LOGIN_DELEGATE_PATH': process.env.VUE_APP_LOGIN_DELEGATE_PATH,
    'VUE_APP_THEME_DARK': process.env.VUE_APP_THEME_DARK,
    'VUE_APP_THEME_LIGHT_PRIMARY': process.env.VUE_APP_THEME_LIGHT_PRIMARY,
    'VUE_APP_THEME_LIGHT_SECONDARY': process.env.VUE_APP_THEME_LIGHT_SECONDARY,
    'VUE_APP_THEME_LIGHT_ACCENT': process.env.VUE_APP_THEME_LIGHT_ACCENT,
    'VUE_APP_THEME_LIGHT_ERROR': process.env.VUE_APP_THEME_LIGHT_ERROR,
    'VUE_APP_THEME_LIGHT_INFO': process.env.VUE_APP_THEME_LIGHT_INFO,
    'VUE_APP_THEME_LIGHT_SUCCESS': process.env.VUE_APP_THEME_LIGHT_SUCCESS,
    'VUE_APP_THEME_LIGHT_WARNING': process.env.VUE_APP_THEME_LIGHT_WARNING,
    'VUE_APP_DISPLAY_KIBANA': process.env.VUE_APP_DISPLAY_KIBANA,
    'VUE_APP_SCOPE_URL': process.env.VUE_APP_SCOPE_URL,
    'VUE_APP_SCOPE_URL_DASHBOARDS': process.env.VUE_APP_SCOPE_URL_DASHBOARDS,
    'VUE_APP_SCOPE_URL_DASHBOARD': process.env.VUE_APP_SCOPE_URL_DASHBOARD,
    'VUE_APP_SCOPE_INSTANCE': process.env.VUE_APP_SCOPE_INSTANCE,
    'VUE_APP_SCOPE_DASHBOARD_GENERAL_ID': process.env.VUE_APP_SCOPE_DASHBOARD_GENERAL_ID,
    'VUE_APP_SCOPE_DASHBOARD_COMMUNITY_ID': process.env.VUE_APP_SCOPE_DASHBOARD_COMMUNITY_ID,
    'VUE_APP_EXPORT': process.env.VUE_APP_EXPORT,
    'VUE_APP_EXPORT_EXTENDED_AVAILABLE': process.env.VUE_APP_EXPORT_EXTENDED_AVAILABLE,
    'VUE_APP_SOLIDARY': process.env.VUE_APP_SOLIDARY,
    'VUE_APP_SOLIDARY_TRANSPORT': process.env.VUE_APP_SOLIDARY_TRANSPORT,
    'VUE_APP_EDITORIAL': process.env.VUE_APP_EDITORIAL,
    'VUE_APP_CAMPAIGN': process.env.VUE_APP_CAMPAIGN,
    'VUE_APP_EVENT': process.env.VUE_APP_EVENT,
    'VUE_APP_EVENT_DESCRIPTION_REQUIRED': process.env.VUE_APP_EVENT_DESCRIPTION_REQUIRED,
    'VUE_APP_EVENT_COMMUNITY': process.env.VUE_APP_EVENT_COMMUNITY,
    'VUE_APP_EVENT_COMMUNITY_REQUIRED': process.env.VUE_APP_EVENT_COMMUNITY_REQUIRED,
    'VUE_APP_ANALYTIC': process.env.VUE_APP_ANALYTIC,
    'VUE_APP_EXTERNAL_JOURNEYS': process.env.VUE_APP_EXTERNAL_JOURNEYS,
    'VUE_APP_HITCH_HIKING': process.env.VUE_APP_HITCH_HIKING,
    'VUE_APP_COMMUNITY': process.env.VUE_APP_COMMUNITY,
    'VUE_APP_COMMUNITY_WITH_FREE_CARPOOL': process.env.VUE_APP_COMMUNITY_WITH_FREE_CARPOOL,
    'VUE_APP_UTC_TIME': process.env.VUE_APP_UTC_TIME,
    'VUE_APP_DISPLAY_ADMIN_BTN': process.env.VUE_APP_DISPLAY_ADMIN_BTN,
    'VUE_APP_RZP_ADMIN_URL': process.env.VUE_APP_RZP_ADMIN_URL,
    'VUE_APP_MINOR_PROTECTION': process.env.VUE_APP_MINOR_PROTECTION,
    'VUE_APP_GEOCOMPLETE_RESULTS_ORDER': process.env.VUE_APP_GEOCOMPLETE_RESULTS_ORDER
  };

  const value = envMap[name];
  console.log(`[getEnv] ${name} = ${value}`);
  return value;
}